import React, { useState, useEffect } from 'react';
import axios from '../../utils/axiosInstance';

const BloodgroupRequest = () => {
  const [requests, setRequests] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(false);

  const limit = parseInt(process.env.REACT_APP_PAGE_LIMIT || 10);

  useEffect(() => {
    fetchRequests(currentPage, searchQuery);
    // eslint-disable-next-line
  }, [currentPage, searchQuery]);

  const fetchRequests = async (page = 1, search = '') => {
    try {
      setLoading(true);
      const res = await axios.get(`/api/blood-group-requests?page=${page}&limit=${limit}&search=${search}`);
      let requestData = [];
      let totalCount = 0;

      if (res.data.bloodGroupRequests) {
        requestData = res.data.bloodGroupRequests;
        totalCount = res.data.count || res.data.bloodGroupRequests.length;
      } else if (Array.isArray(res.data)) {
        requestData = res.data;
        totalCount = res.data.length;
      } else {
        requestData = [];
        totalCount = 0;
      }

      setRequests(requestData);
      setTotalPages(Math.ceil(totalCount / limit));
    } catch (err) {
      // Optionally show error
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-2">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="mb-0">BloodgroupRequest</h3>
        <input
          type="text"
          className="form-control w-25"
          placeholder="Search BloodgroupRequest..."
          value={searchQuery}
          onChange={(e) => {
            setSearchQuery(e.target.value);
            setCurrentPage(1);
          }}
        />
      </div>

      <div className="card shadow-sm">
        <div className="card-header d-flex justify-content-between align-items-center p-2">
          <h5 className="mb-0">BloodgroupRequest</h5>
        </div>
        <div className="table-responsive">
          <div className="card-body p-0">
            <table className="table table-bordered table-sm mb-0" style={{ fontSize: '14px', lineHeight: '2' }}>
              <thead className="table-light">
                <tr>
                  <th className="py-1 px-2 w-5">Sr no.</th>
                  <th className="py-1 px-2">Name</th>
                  <th className="py-1 px-2">Mobile Number</th>
                  <th className="py-1 px-2">Blood Group</th>
                  <th className="py-1 px-2">Given By</th>
                  <th className="py-1 px-2">Description</th>
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="6" className="text-center py-3">
                      <div className="spinner-border text-primary" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </td>
                  </tr>
                ) : requests.length > 0 ? (
                  requests.map((item, idx) => (
                    <tr key={item._id || idx}>
                      <td className="py-1 px-2">{(currentPage - 1) * limit + idx + 1}</td>
                      <td className="py-1 px-2">{item.name || <span className="text-muted">-</span>}</td>
                      <td className="py-1 px-2">{item.mobileNumber || <span className="text-muted">-</span>}</td>
                      <td className="py-1 px-2">{item.bloodGroup?.name || <span className="text-muted">-</span>}</td>
                      <td className="py-1 px-2">
                        {item.givenByUser
                          ? (
                              <>
                                <span>
                                  { [
                                      item.givenByUser.firstName,
                                      item.givenByUser.middleName,
                                      item.givenByUser.lastName
                                    ].filter(Boolean).join(' ') || <span className="text-muted">-</span> }
                                </span>
                                <br />
                              </>
                            )
                          : <span className="text-muted">-</span>
                        }
                      </td>
                      <td className="py-1 px-2" style={{ maxWidth: 350 }}>
                        {item.description
                          ? (item.description.length > 100
                              ? item.description.substring(0, 100) + '...'
                              : item.description
                            )
                          : <span className="text-muted">-</span>
                        }
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-2">No Blood Group Requests found.</td>
                  </tr>
                )}
              </tbody>
            </table>

            {totalPages > 1 && (
              <div className="d-flex justify-content-end align-items-center gap-2 p-2">
                <button
                  className="btn btn-sm btn-outline-secondary"
                  disabled={currentPage === 1}
                  onClick={() => setCurrentPage(currentPage - 1)}
                >
                  &laquo;
                </button>
                {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
                  <button
                    key={page}
                    className="btn btn-sm"
                    style={{
                      backgroundColor: currentPage === page ? '#F94F01' : 'transparent',
                      color: currentPage === page ? 'white' : '#F94F01',
                      border: '1px solid #F94F01'
                    }}
                    onClick={() => setCurrentPage(page)}
                  >
                    {page}
                  </button>
                ))}
                <button
                  className="btn btn-sm btn-outline-secondary"
                  disabled={currentPage === totalPages}
                  onClick={() => setCurrentPage(currentPage + 1)}
                >
                  &raquo;
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BloodgroupRequest;